import { queryOptions } from '@tanstack/react-query'

import { LegacyParams } from '@/types/supports'

import { fetchHelpRequestTypes, submitSupportForm } from './methods'

const helpRequestTypeQueryKeys = {
  all: ['helpRequestTypes'] as const,
  list: (params: LegacyParams) => [...helpRequestTypeQueryKeys.all, 'list', params] as const
} as const

export const helpRequestTypeQueryOptions = {
  list: (params: LegacyParams) =>
    queryOptions({
      queryKey: helpRequestTypeQueryKeys.list(params),
      queryFn: () => fetchHelpRequestTypes(params)
    }),
  create: {
    mutationFn: submitSupportForm
  }
}
